export const buildingBrochure = {
    "subtitle": "Nuestro servicio",
    "fast_pay": "Pago rápido",
    "fast_pay_1": "Pago rápido a través de Bllink",
    "fast_pay_2": "permite que el edificio acepte fondos",
    "fast_pay_3": "directo a la cuenta bancaria del edificio",
    "fast_pay_4": "y gestione de forma inteligente el proceso de los pagos.",
    "qr_title": "Para realizar un pago rápido, escanea el código QR o ponte en contacto",
    "card": "Tarjeta de crédito",
    "invoice": "Factura",
    "reminders": "Recordatorios",
    "pci": "Compatible con la Industria de Tarjeta de Pago (Payment Card Industry, PCI)",
    "fileName": "building_brochure",
    "phone": "Para realizar el pago rápidamente - escanee el código",
    "wire": "Transferencia bancaria",
    "title": "Aviso de pago del"
};
